module.exports = "<div class=\"row\" style=\"padding: 10px;\">\n    <div class=\"col-md-12 col-lg-12\">\n        <div class=\"user-item\" *ngFor=\"let user of data.approvalGroupMembers\">\n            <div>{{user.firstName + ' ' + user.lastName}}</div>\n            <div>{{user.email}}</div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/organization/components/approvals/approval-group-details/approval-group-details.component.html
// module id = ./src/app/organization/components/approvals/approval-group-details/approval-group-details.component.html
// module chunks = main